<div *ngFor="let chartData of chartDataArray">
    <apx-chart [series]="chartData.series" [chart]="chartData.chart"></apx-chart>
  </div>
